<template>
    <div class="stage-indicator" v-if="showIndicator">
        {{ stageName }}
    </div>
</template>

<script setup>
import { useStageIndicator } from './composables/useStageIndicator';

// Use the stage indicator composable
const { stageName, showIndicator } = useStageIndicator();
</script>

<style lang="scss" scoped>
.stage-indicator {
    color: #fff;
    display: flex;
    align-items: center;
    padding: 0 10px;
}
</style>
